export default "assets/images/icons/dropdown-e5549afe.svg";